import { render } from "./MerchantsPage.vue?vue&type=template&id=40860514&scoped=true"
import script from "./MerchantsPage.vue?vue&type=script&lang=js"
export * from "./MerchantsPage.vue?vue&type=script&lang=js"

import "./MerchantsPage.vue?vue&type=style&index=0&id=40860514&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40860514"]])

export default __exports__